import React, { useState } from 'react';
import MainLayout from '../../layouts/mainLayout';
import './style.scss';
import InputWithLabel from '../../components/inputWithLabel';
import LoginBtn from '../../components/buttons/loginBtn';
import { emailRegex } from '../../utils/data';
import { loginApi, checkEmailAndPassword } from '../../api/apis/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { addToken } from '../../functions/localStorage';
import { getPathAcctoYear } from '../../utils/functions/common';

const Login = () => {

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const [passwordExist, setPasswordExist] = useState(false);
  const navigate = useNavigate();
  

  const handleInputChange = (e) => {
    const { name, value } = e?.target ?? {};
    setFormData(prev => ({ ...prev, [name]: value }))
    setErrors(prev => ({ ...prev, [name]: "" }))
  }

  const handleClick = async () => {
    setLoading(true)
    if (!passwordExist) {
      try {
        const { data } = await checkEmailAndPassword(formData);
        if (data?.status === "success") {
          if (data?.data?.passwordExist) {
            setPasswordExist(data?.data?.passwordExist)
          } else {
            navigate(getPathAcctoYear("/create-password"), { state: { email: formData?.email } })
          }
        } else {
          setErrors({ submit: data?.message })
        }

      } catch (error) {
        console.log(error)
      }
    } else {
      try {
        const { data } = await loginApi(formData);
        if (data?.status === "success") {
          addToken(data?.data?.token)
          if (location?.state?.from?.pathname === getPathAcctoYear("/questions")) {
            navigate(location?.state?.from?.pathname + location?.state?.from?.search)
          } else {
            navigate(getPathAcctoYear(data?.data?.nda_status?.accepted ? "/location" : "/disclaimer"))
          }
        } else {
          setErrors({ submit: data?.message })
        }

      } catch (error) {
        console.log(error)
      }
    }
    setLoading(false)
  }

  const btnDisabled = formData?.email === '' || emailRegex.test(formData?.email) === false;

  const onKeyDown = (e) => {
    if (e?.keyCode === 13 && !(btnDisabled || loading)) {
      handleClick()
    }
  }

  const forgotPassword = async () => {
    navigate(getPathAcctoYear("/forgot-password"))
  }

  return (
    <MainLayout>
      <div className='login__section'>
        <h3>
          Welcome to FlexGrade
        </h3>
        <br />
        <p className='welcome__description'>
          The Flex Workspace’s Industry First-Ever Quality Standardization
          <br />
          <br />
          Thank you for taking this important step toward certification. Your commitment to quality excellence sets you apart. Please use your registered email to log in to begin your assessment.
        </p>
        <div className='input__section'>
        <InputWithLabel disabled={passwordExist} onKeyDown={onKeyDown} value={formData?.email} label={"Email address"} requried={true} name={"email"} onChange={handleInputChange} placeholder={"email@email.com"} />
          {passwordExist ? <InputWithLabel type={'password'} classes={"mt-4"} value={formData?.password} onKeyDown={onKeyDown} label={"Password"} requried={true} name={"password"} onChange={handleInputChange} placeholder={"XXXX"} /> : ""}
          <LoginBtn onClick={handleClick} disabled={btnDisabled || loading} loading={loading} text={"Login"} />
          {passwordExist ? <div className='d-flex w-100 justify-content-end'>
            <button onClick={forgotPassword} className='forgot__password'>Forgot Password?</button>
          </div>:""}
          {errors?.submit ? <p className='error__message'>{errors?.submit}</p> : ""}
        </div>
      </div>
    </MainLayout>
  )
}

export default Login